module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAmCAMAAAAcJyCnAAAAZlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+Vn2moAAAAIXRSTlMAlhGlIjM6Cgb37NXAoIR1akMwDYws6OTHtpGKR+DaqkvZPhOEAAAAtUlEQVQoz93TWQ6DIBSF4aMiaBXFeexw97/JOkFuGxbQ9H8g5AtPF8BeyMNZfCPebT1PTsRLOwBVVsGkTEtstUSzEqPDHHvBtluAOr5KnEZg/ZlqKGFrnErRky07VA5UIGeDTEwIIDRJSWyQBQ0S8QvIHPZCbmuAgHTTCJuCvpTuHeCKrJL2avQDWvj0oXwqE/ueamA5tP0Y5CjUTNRCPvkgKTXH2wW6lHjTeUfr1w+oAf9veQOTACY8ZctLMwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/progressPage/num-6.png
// module id = 3fu/
// module chunks = 1